import { Component,HostListener} from '@angular/core';
import { NavigationStart, Router, RouterOutlet } from "@angular/router";
import { environment } from 'src/environments/environment';
import { FooterComponent } from './modules/comum/footer/footer.component';
import { HeaderComponent } from './modules/comum/header/header.component';
import { NgIf } from '@angular/common';
import { LoaderComponent } from './modules/comum/loader/loader.component';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    standalone: true,
    imports: [LoaderComponent, NgIf, HeaderComponent, RouterOutlet, FooterComponent]
})
export class AppComponent {
  title = 'front-serasajude';

  showHead: boolean = false;

  constructor(private router: Router) {
    this.initializeLocal();
  }

  private initializeLocal() {
    this.router.events.forEach((event) => {
      if (event instanceof NavigationStart) {
        if (event['url'] == '/login'  || event['url'] == '/' || event['url'] == '/login-identifique' ) {
          if (environment.local) {
            const JWTToken = window.prompt("FAVOR INFORMAR O JWT-TOKEN");
            const cargo = window.prompt("FAVOR INFORMAR O CARGO ");

            sessionStorage.setItem("JWTToken", JWTToken);
            sessionStorage.setItem("cargo", cargo.toUpperCase());
            sessionStorage.setItem("usuario", JSON.stringify(
              {
                id: "5e6a60ebfb8c581831e4ddc2",
                fullName: "Viviane Rios",
                document: { documentId: "39793938870", documentCountry: "BRA" },
                birthDate: "1990-01-01",
                email: {
                  email: "leticia.canali@br.experian.com",
                  validatedStatus: "NOT_VALIDATED",
                },
                mobile: {
                  regionCode: 55,
                  areaCode: 11,
                  phoneNumber: 997141476,
                },
                userEcs: {
                  hercules: { fraudnet: "Aprovado" },
                  picture:
                    "https://www.serasaconsumidor.com.br/navbar-avatar.png",
                },
              })
            );
            this.showHead = true;
            this.router.navigate(["/ordem"]);

            return;
          }
          this.showHead = false;
        } else {
          this.showHead = true;
        }
      }
    });
  }

  @HostListener("window:onbeforeunload",["$event"])
  clearLocalStorage(event){
    sessionStorage.clear();
  }
}
